/**
 * Единая навигация по push (foreground, SW postMessage, клик по системному уведомлению).
 * Приоритет: route из user_notifications → user_notification_id → legacy type mapping.
 */
export function resolvePushNotificationUrl(data: Record<string, string | undefined> | null | undefined): string {
  if (!data) {
    return '/'
  }

  const route = data.route
  if (route && route.startsWith('/')) {
    return route
  }

  if (data.user_notification_id) {
    return `/notifications?id=${data.user_notification_id}`
  }

  const type = data.type || ''

  if (type.startsWith('funnel_')) {
    return resolveFunnelLeadUrl(data.leadable_type, data.leadable_id) || '/funnel/notifications'
  }

  switch (type) {
    case 'order_request':
      return data.entity_id ? `/requests?request_id=${data.entity_id}` : '/requests'
    case 'order_request_email':
      return data.entity_id
        ? `/order-requests/${data.entity_id}/email-history`
        : '/requests'
    case 'call_incoming':
    case 'call_missed':
      return data.route && data.route.startsWith('/') ? data.route : '/novofon'
    case 'tochka_payment':
      return data.entity_id ? `/money?payment_id=${data.entity_id}` : '/money'
    case 'task_reminder':
      return data.entity_id ? `/tasks?task_id=${data.entity_id}` : '/tasks'
    case 'task':
      return data.task_id ? `/tasks?task_id=${data.task_id}` : '/tasks'
    case 'daily_tasks':
      return '/tasks'
    case 'new_order_request':
      return data.order_request_id
        ? `/requests?request_id=${data.order_request_id}`
        : '/requests'
    case 'new_email_in_request':
      return data.order_request_id
        ? `/order-requests/${data.order_request_id}/email-history`
        : '/requests'
    case 'missed_call':
    case 'incoming_call':
      return '/novofon'
    case 'regular_payment':
      return data.payment_id ? `/money?payment_id=${data.payment_id}` : '/money'
    case 'subscription_updated':
    case 'subscription_expiring':
      return '/subscription'
    case 'company_invitation':
      return data.company_id ? `/customers?company_id=${data.company_id}` : '/profile'
    case 'new_order':
    case 'order_in_print_queue':
    case 'comment_mention':
      return data.order_id ? `/orders/${data.order_id}` : '/orders'
    case 'overdue_task':
    case 'unassigned_lead':
    case 'high_priority_no_activity':
    case 'no_call_reminder':
    case 'customer_task_created':
    case 'stage_progression':
    case 'lead_assigned':
    case 'high_lead_score':
    case 'conversion_milestone':
      return resolveFunnelLeadUrl(data.leadable_type, data.leadable_id) || '/funnel'
    default:
      return '/'
  }
}

function resolveFunnelLeadUrl(leadableType?: string, leadableId?: string): string | null {
  if (!leadableType || !leadableId) {
    return null
  }

  if (leadableType.includes('Customer')) {
    return `/funnel/lead/customer/${leadableId}`
  }

  if (leadableType.includes('OrderRequest')) {
    return `/funnel/lead/order-request/${leadableId}`
  }

  const leadType = leadableType.split('\\').pop()?.toLowerCase() || 'lead'
  return `/funnel/lead/${leadType}/${leadableId}`
}

export function resolvePushNotificationTag(data: Record<string, string | undefined> | null | undefined): string {
  if (!data) {
    return `crm-unknown-${Date.now()}`
  }

  if (data.tag) {
    return data.tag
  }

  const type = data.type || 'unknown'

  if (data.user_notification_id) {
    return `crm-user-notification-${data.user_notification_id}`
  }

  if (data.notification_id) {
    return `crm-${type}-${data.notification_id}`
  }

  if (data.order_request_id) {
    return `crm-${type}-order-request-${data.order_request_id}`
  }

  if (data.task_id) {
    return `crm-${type}-task-${data.task_id}`
  }

  if (data.payment_id) {
    return `crm-${type}-payment-${data.payment_id}`
  }

  if (data.order_id) {
    return `crm-${type}-order-${data.order_id}`
  }

  if (data.entity_id && data.entity_type) {
    const entityTypeClean = data.entity_type.replace(/\\/g, '-')
    return `crm-${type}-${entityTypeClean}-${data.entity_id}`
  }

  if (data.leadable_id && data.leadable_type) {
    const leadableTypeClean = data.leadable_type.replace(/\\/g, '-')
    return `crm-${type}-${leadableTypeClean}-${data.leadable_id}`
  }

  return `crm-${type}-${Date.now()}`
}
